import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { ToggleEnterpriseRequest, ToggleEnterpriseResponse } from './types';

type ToggleEnterpriseProps = {
  artistId: string;
  enable: boolean;
};

export const toggleEnterprise = async ({ artistId, enable }: ToggleEnterpriseProps) => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/account/enterprise`;

  const payload: ToggleEnterpriseRequest = {
    enable,
  };

  const response = await api.executePostRequest<ObjectResponse<ToggleEnterpriseResponse>>(url, payload);

  return response.data;
};
